import { render, staticRenderFns } from "./pageElementConfig.vue?vue&type=template&id=6e83a720"
import script from "./pageElementConfig.vue?vue&type=script&lang=js"
export * from "./pageElementConfig.vue?vue&type=script&lang=js"
import style0 from "./pageElementConfig.vue?vue&type=style&index=0&id=6e83a720&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports